import * as React from "react"
import { Badge, Box } from "@mui/material"

import { STOCK_STATUS } from "../../@constants"

const STOCK_FACTORY = {
	[STOCK_STATUS.STOCK]: '#54d62c',
	[STOCK_STATUS.CLICK_AND_COLLECT]: '#ffc107',
	[STOCK_STATUS.OUT_OF_STOCK]: '#FF4842',
	[STOCK_STATUS.DESLISTED]: 'disabled.light'
}


export default function stockStatusColumn() {
	return [{
		name: 'stock', label: 'Stock Status',
		options: {
			display: 'excluded',
			customBodyRowRender: value => {
				if (value === STOCK_STATUS.STOCK) return 'In Stock'
				if (value === STOCK_STATUS.CLICK_AND_COLLECT) return 'Click and Collect'
				if (value === STOCK_STATUS.OUT_OF_STOCK) return 'Out of Stock'
			}
		}
	}, {
		name: 'stock', label: 'Stock Status',
		options: {
			filter: false,
			setCellHeaderProps: () => ({
				sx: { whiteSpace: 'normal', maxWidth: 30 }
			}),
			customBodyRowRender: value => {
				return <Box sx={{ textAlign: 'center' }}>
					<Badge sx={{ span: { backgroundColor: STOCK_FACTORY[value] } }} badgeContent=" " />
				</Box>
			}
		}
	}]
}